import {ToggleTree} from "toggletree";

export class Navigation {
    constructor() {
        // segment blocks (dashboard)
        if (document.querySelector('nav.segment-blocks')) {
            this.segmentBlocks = $('.segment-blocks ul li.menu-segment');

            this.init();
            this.rearrangeBlocks();
            this.handleResize();
        }

        const scope = this;

        // left navigation
        if (document.querySelector('nav.menu-left')) {
            this.menuLeft         = $('nav.menu-left');
            this.contentContainer = $('.content-container');

            this.manageCookies();
            this.collapse();
            this.showOpenedSegments();

            document.querySelector('.menu-btn').onclick = event => {
                if (scope.menuLeft[0].classList.contains('menu-in')) {
                    scope.showMenu(true);
                }
                else {
                    scope.hideMenu(true);
                }
            };
        }
    }

    init() {
        if (document.querySelector('.shortcuts.right')) {
            document.querySelector('body').classList.add('shortcuts-right');
        }
    }

    handleResize() {
        let prevWidth = $(window).width(),
            scope     = this;

        $(window).resize(function() {
            let windowWidth     = $(window).width(),
                smallerOrBigger = windowWidth > prevWidth ? 'bigger' : 'smaller';

            prevWidth = windowWidth;

            scope.rearrangeBlocks(smallerOrBigger)
        });
    }

    rearrangeBlocks(smallerOrBigger = 'smaller') {
        let previousBlock = null;

        $.each(this.segmentBlocks, function (index, element) {
            let block = $(element);

            if (previousBlock !== null) {
                if (block.offset().top !== previousBlock.offset().top) {
                    let offsetLeft  = previousBlock.offset().left,
                        outerWidth  = previousBlock.outerWidth(),
                        windowWidth = $(document).width(),
                        offSetRight = (windowWidth - (offsetLeft + outerWidth));

                    if (offSetRight > 310) {
                        if (smallerOrBigger == 'smaller') {
                            let nextSmallItem = $(previousBlock.nextAll('.small-item')[0]);

                            if (nextSmallItem.length) {
                                nextSmallItem.insertAfter(previousBlock);
                            }
                        }
                    }
                } else {
                    previousBlock.removeClass('last-of-row');
                }
            }

            previousBlock = $(block);
        });
    }

    hideMenu(animate) {
        document.querySelector('.menu-btn').classList.remove('hide-menu');
        document.querySelector('.menu-btn').classList.add('show-menu');

        this.menuLeft[0].classList.remove('menu-out');
        this.menuLeft[0].classList.add('menu-in');

        this.toggleAnimationClass(animate);

        $.cookie('admin_navigation_collapsed', null, { path: '/' });

        document.dispatchEvent(new CustomEvent('navigation-hidden'));
    }

    showMenu(animate) {
        document.querySelector('.menu-btn').classList.add('hide-menu');
        document.querySelector('.menu-btn').classList.remove('show-menu');

        this.menuLeft[0].classList.remove('menu-in');
        this.menuLeft[0].classList.add('menu-out');

        this.toggleAnimationClass(animate);

        $.cookie('admin_navigation_collapsed', 1, { path: '/' });

        document.dispatchEvent(new CustomEvent('navigation-shown'));
    }

    toggleAnimationClass(animate) {
        if (animate) {
            this.menuLeft[0].classList.add('animate');
            this.menuLeft[0].classList.remove('static');
        }
        else {
            this.menuLeft[0].classList.remove('animate');
            this.menuLeft[0].classList.add('static');
        }
    }

    collapse() {
        if (typeof $.cookie('admin_navigation_collapsed') != 'undefined' && $.cookie('admin_navigation_collapsed') == 1){
            this.showMenu(false);
        }
        else {
            this.hideMenu(false);
        }
    }

    manageCookies() {
        const scope = this;

        // Save opened segments in cookie
        $(document).on('click', '.menu-left ul li a', function (){
            let activeNavItems = [];

            scope.menuLeft.find('> ul > li').each(function( index ) {
                if ($(this).hasClass('active')) {
                    activeNavItems.push(index);
                }
            });

            $.cookie('admin_navigation_active_items', activeNavItems, { path: '/' });
        });
    }

    showOpenedSegments() {
        const toggletree = new ToggleTree(document.querySelector('nav.menu-left'));
        const scope      = this;

        // Show opened segments on pageload
        if ($.cookie('admin_navigation_active_items')){
            let activeNavItems = $.cookie('admin_navigation_active_items').split(',');

            $.each(activeNavItems, function( index, value ) {
                let listItem = scope.menuLeft.find('li.menu-segment[data-navigation-item="' + value + '"]')[0];

                if (listItem !== undefined) {
                    toggletree.show(listItem);
                }
            });
        }
    }
}
